module.exports = __webpack_public_path__ + "static/scale-model-of-des-moines-iowa-07642c53e498a161e610a59c5e30ffe4.png";